// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MyWorkContext } from 'pages/Portfolio/MyWork/MyWork';
import React, { useContext } from 'react';
import './Row.module.scss';
// =========================

type Props = {
  name: string;
  id: number;
};

export default function Row({ name, id }: Props) {
  const { selectedPortfolios, setSelectedPortfolios } = useContext(
    MyWorkContext
  );

  const active = selectedPortfolios.includes(id);

  return (
    <div
      onClick={() =>
        setSelectedPortfolios((prev) =>
          prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
        )
      }
      styleName={`row ${active ? 'active' : null}`}
    >
      <p>{name}</p>
      <div styleName="icons">
        <div />
        <>
          <FontAwesomeIcon
            styleName={`icon ${active ? 'rotated' : null}`}
            icon={faPlus}
          />
        </>
      </div>
    </div>
  );
}
